<template>
  <section id="hero">
    <base-jumbotron
      :src="require('@/assets/bg.jpg')"
      color="grey darken-4"
      dark
      height="100%"
      min-height="100vh"
    >
      <v-row
        align="center"
        class="pb-12"
      >
        <v-col
          cols="12"
          md="5"
        >
          <div>
            <base-title>
              More trees<br>
              for free
            </base-title>

            <v-divider class="mb-3" />

            <div class="subheading mb-4">
              <p>Rosian SCIO is a charity based in Glasgow, Scotland.</p>

              <p>
                You can get your favourite online stores to plant trees after each purchase you make... at no additional cost to you!
              </p>
            </div>

            <!--
            <v-btn
              color="primary"
              class="ma-0"
              large
            >
              Get Started Today
              <v-icon right>
                mdi-school
              </v-icon>
            </v-btn>
            -->
          </div>
        </v-col>
      </v-row>
    </base-jumbotron>
  </section>
</template>

<script>
  export default {
    name: 'HomeHero'
  }
</script>
